/**
 * Section - Consistent section wrapper with spacing and background variants
 */

import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'secondary' | 'gradient';
  spacing?: 'sm' | 'md' | 'lg' | 'xl';
  container?: boolean;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

const spacingMap = {
  sm: 'py-12 md:py-16',
  md: 'py-16 md:py-24',
  lg: 'py-20 md:py-32',
  xl: 'py-24 md:py-40',
};

const maxWidthMap = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-5xl',
  xl: 'max-w-6xl',
  '2xl': 'max-w-7xl',
  full: 'max-w-full',
};

export function Section({
  children,
  className,
  variant = 'default',
  spacing = 'md',
  container = true,
  maxWidth = 'xl',
}: SectionProps) {
  const variantClasses = {
    default: 'bg-background',
    secondary: 'bg-secondary/30',
    gradient: 'bg-gradient-to-b from-background via-secondary/20 to-background',
  };

  return (
    <section className={cn(spacingMap[spacing], 'px-4', variantClasses[variant], className)}>
      {container ? (
        <div className={cn('container mx-auto', maxWidthMap[maxWidth])}>
          {children}
        </div>
      ) : (
        children
      )}
    </section>
  );
}

